import React from "react";
import { Route, Routes, Outlet } from "react-router-dom";
import DashBoard from "../components/DashBoard";
import Jobs from "../components/Jobs/Jobs";
import JobsEvents from "../components/Jobs/JobsEvent";
import PrepTeamQueue from "../components/PrepTeamQUeue/PrepTeamQueue";
import AddPreprocessing from "../components/PrepTeamQUeue/AddPreProcessing";
import UserUploadLogs from "../components/UploadLogs/UserUploadLogs";
import JobEventUploadLogs from "../components/UploadLogs/JobEventUploadLogs";
import NotFound from "../components/404/NotFound";
import HistoryTable from "../components/Jobs/HistoryTable";
import AllBoxes from "../components/BoxProcessing/AllBoxes";
import BoxHistory from "../components/BoxProcessing/BoxHistory";
import UserDashBoard from "../components/UserDashBoard";
import JobsEventsDetailsAdmin from "../components/Jobs/JobsEventsDetailsAdmin";
import EventStagesHistory from "../components/Jobs/EventStagesHistory";


const UserRoutes = () => {
   return (
      <Routes>
         <Route path="/" element={<Outlet />}>
            <Route path="dashboard" element={<UserDashBoard />} />
            <Route path="jobs" element={<Jobs />} />
            <Route path="jobs/jobs_event/:id" element={<JobsEvents />} />
            <Route path="/prep-queue" element={<PrepTeamQueue />} />
            <Route path="/add-preprocess/:id" element={<AddPreprocessing />} />
            <Route path="/upload-log" element={<UserUploadLogs />} />
            <Route path="/job-event-log" element={<JobEventUploadLogs />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/view-history/:id" element={<HistoryTable />} />
            <Route path="/all-boxes" element={<AllBoxes />} />
            <Route path="/box-history" element={<BoxHistory />} />
            <Route path="jobs/job_event/:id" element={<JobsEvents />} />
            <Route path="/view-event-stages-history/:id" element={<EventStagesHistory />} />


         </Route>
      </Routes>
   );
};

export default UserRoutes;
